export const firebaseConfig = {
  apiKey: "AIzaSyDPMkVgWhkPLIEFqcVCIR6jtHMFvOOwaBs",
  authDomain: "amdash-eccb0.firebaseapp.com",
  databaseURL: "https://amdash-eccb0.firebaseio.com",
  projectId: "amdash-eccb0",
  storageBucket: "amdash-eccb0.appspot.com",
  messagingSenderId: "31336010927",
  appId: "1:31336010927:web:6773aafc14bfc790dc305a"
};